import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';
import classNames from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphMetrics as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphMetricsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
  isLarge?: boolean;
}

const ParagraphMetrics: React.FC<ParagraphMetricsProps> = ({
  entity,
  isLarge = false,
}) => {
  const paragraphMetrics = entity.toJS();
  const title = paragraphMetrics.field_title[0]?.value;
  const body = paragraphMetrics.field_body[0]?.processed;
  const metricItems = paragraphMetrics.field_paragraphs;

  return (
    <div className="Paragraph ParagraphMetrics">
      <Container>
        <div className="row">
          <div className={isLarge ? 'col-12 col-lg-8 ' : 'offset-md-1 col-lg-8 offset-lg-2'}>
            <h2>{title}</h2>
            <WysiwygField html={body} />
          </div>
          <div className={isLarge ? 'col-12' : 'offset-md-1 col-lg-8 offset-lg-2'}>
            <div className="ParagraphMetrics__subparagraphs">
              {metricItems.map((metricItem) => {
                const id = metricItem.target_id;

                return (
                  <Paragraph
                    key={`paragraph:${id}`}
                    id={id}
                    entity={Immutable.fromJS(metricItem.entity)}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphMetrics;
